var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.103 15.8735L9.08 15.6025L14.68 9.99749L11.984 7.30049L6.367 12.9175L6.103 15.8735ZM13.324 5.96149L16.019 8.65649L17.966 6.70649L15.272 4.01249L13.324 5.96149ZM4.293 17.6855C4.083 17.4755 3.978 17.1835 4.004 16.8875L4.383 12.7175C4.425 12.2605 4.627 11.8295 4.953 11.5035L13.949 2.50749C14.651 1.80249 15.924 1.83749 16.665 2.57649L19.403 5.31449L19.404 5.31549C20.169 6.08149 20.2 7.29949 19.472 8.02949L10.475 17.0265C10.15 17.3515 9.719 17.5535 9.261 17.5955L5.091 17.9745C5.061 17.9765 5.031 17.9775 5 17.9775C4.737 17.9775 4.482 17.8735 4.293 17.6855ZM20 20.9775C20 21.5275 19.55 21.9775 19 21.9775H5C4.451 21.9775 4 21.5275 4 20.9775C4 20.4285 4.451 19.9775 5 19.9775H19C19.55 19.9775 20 20.4285 20 20.9775Z",
    fill: "#064E72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.308a59c3.svg";
export { ForwardRef as ReactComponent };